import React, { useEffect, useRef, useState, useMemo, useContext } from "react";
import { Alert, Box, Button, Checkbox, CircularProgress, Chip, FormControl, FormControlLabel, Grid, LinearProgress, Paper, patch, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import CheckIcon from '@mui/icons-material/Check';
import Timer from '../CallBacks/Timer';
import ApiService from "../../functions/apiService";
import { useSnackbar } from "notistack";
import { useNavigate } from "react-router-dom";
import { useParams } from 'react-router';
import ModalBox from '../../components/Modal/ModalBox';
import { Link } from "react-router-dom";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import moment from 'moment/moment';
import AuthContext from "../../context/AuthContext";
import { toast } from "react-toastify";
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";
import './fillShift.css';

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value,
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

const checkButtonStyle = {
  color: "#FFF",
  minWidth: "0",
  paddingRight: ".02rem",
  background: '#01784F',
  padding: '8px',
  ":hover": { color: "#fff", background: "#01784F" },
  ":disabled": { color: "#fff", background: '#D0D5DD' }
};

const ShiftWork = () => {
  var params = useParams();
  const batch_id = params.batch_id;
  const { job_id } = params;
  // const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [reloadData, setReloadData] = useState(false);
  const [submiting, setSubmiting] = useState(false);
  const [submitingPause, setSubmitingPause] = useState(false);
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [viewJobs, setViewJobs] = useState(false);
  const [viewJobsEmp, setViewJobsEmp] = useState([]);
  const [viewJobsEmpDiscard, setViewJobsEmpDiscard] = useState([]);
  const [ProgressValue, setProgressValue] = useState(0);
  const [empNowSending, setEmpNowSending] = useState(0);
  const [isPaused, setIsPaused] = useState(true);
  const [timerCount, setTimerCount] = useState(5);
  const [patchId, setPatchId] = useState('');
  const [backMode, setBackMode] = useState(true);
  const [fromPreAccept, setFromPreAccept] = useState(false);
  const [returnbatches, setReturnbatches] = useState([]);
  const [overTime, setOverTime] = useState([]);
  const intervalId = useRef(null);
  const scrollToRef = useRef(null);
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);
  const handleModalClose = () => { setShowModal(false); };
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [selectedShift, setSelectedShift] = useState(null);
  const pauseId = overTime.map((i) => i.patch_id);
  const [pauseGrenga, setPauseGrenga] = useState('');
  const { pages } = useContext(AuthContext);
  const [newDataArray, setNewDataArray] = useState([]);
  const [shiftDate, setShiftDate] = useState('');
  const [shiftCode, setShiftCode] = useState(0);
  const [shiftNumber, setShiftNumber] = useState('');
  const [show, setShow] = useState(false);
  
  const [requestMessage, setRequestMessage] = useState('');
  const [notOfferedEmp, setNotOfferedEmp] = useState([]);
  const [acceptText, setAcceptText] = useState('')
  const [rejectData, setRejectData] = useState([])
  const [showAccept, setShowAccept] = useState(false)
  const [showReject, setShowReject] = useState(false)
  const [acceptData, setAcceptData] = useState([])
  const [rejectapiData, setRejectapiData] = useState([])
  const [empsNoMarks, setEmpsNoMarks] = useState([])

	const [offerTime , setOfferTime] = useState([])
	const [count , setCount] = useState(0);
	const [grengaList , setGrengaList] = useState([]);
	const [olpShifts , setOlpShifts] = useState([]);
	const [oslUserRejected , setOslUserRejected] = useState([]);
	const [rankChangeData , setRankChangeData] = useState([]);
	const [isWatchParty, setIsWatchParty] = useState(false);
	const [grengaDeactiveList , setGrengaDeactiveList] = useState([]);
	const [showModal2, setShowModal2] = useState(false);
	const [emergencyList, setEmergencyList] = useState([])
	const [overtimeList, setOvertimeList] = useState([])
	const [listType, setListType] = useState('Upcoming')
const[listArr,setListArr]=useState([]);
	const [allowedVars, setAllowedVars] = useState([])
  const [emergencyPauseLoad, setEmergencyPauseLoad] = useState(false);

  const [timer, setTimer] = useState(() => {
    const storedTimer = localStorage.getItem('Timer');
    return storedTimer ? JSON.parse(storedTimer)[0] : 5;
  });
	const timerRef = useRef(timer);

	useEffect(() => {
		timerRef.current = timer;
	}, [timer]);

	useEffect(() => {
		let urlArr = window.location.pathname.split('/')
		if (urlArr[2] == 'watch-party-work') {
			setIsWatchParty(true)
		}
	},[])

	const columnsJobs = () => {
		let columns = [
			{
				field: 'fullName', headerName: 'Name', flex: 1, minWidth: 300,
				renderCell: (params) => {
					const empCode = params?.row?.Emp_Code;
					const shiftType = params?.row?.Shift_Type;
					const key = `${shiftType}-${empCode}`;
					const matchGrenga = grengaList?.hasOwnProperty(key);
					const matchGrengaDeactive = grengaDeactiveList?.hasOwnProperty(key);
          const matchRankChange =  rankChangeData[empCode] === shiftType;
					const fullName = `${params?.row?.employee_assignment_for_rank?.EA_Rank || ''} ${params?.row?.employee?.fullName || ''}`;

					return (
						<Box
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								gap: 1,
								minWidth: 0,
							}}
						>
							<Typography
								sx={{
									flex: 1,
									whiteSpace: 'nowrap',
									overflow: 'hidden',
									textOverflow: 'ellipsis',
								}}
							>
								{fullName}
							</Typography>

							{matchGrenga && (
								<Chip
									sx={{
										backgroundColor: 'orange',
										color: '#000000',
										height: '32px',
										px: 1,
										flexShrink: 0,
									}}
									label='On Duty'
								/>
							)}
              {matchRankChange && (
								<Chip
									sx={{
										backgroundColor: 'orange',
										color: '#000000',
										height: '32px',
										px: 1,
										flexShrink: 0,
									}}
									label='Rank Change'
								/>
							)}
							{matchGrengaDeactive && (
								<Chip
									sx={{
										backgroundColor: '#C0C0C0',
										color: '#000000',
										height: '32px',
										px: 1,
										flexShrink: 0,
									}}
									label='On Duty'
								/>
							)}
						</Box>
					);
				}
			},
			{
				field: 'EMS_Cert', headerName: 'EMT', flex: 1, minWidth: 80,
				valueGetter: (params) => {
					return `${params?.row?.employee?.EMS_Cert || ''}`;
				}
			},
			{
				field: 'State',
				headerName: 'State',
				flex: 1,
				minWidth: 140,
				renderCell: (params) => {
					const empCode = params?.row?.Emp_Code;
					const shiftType = params?.row?.Shift_Type;
					const key = `${empCode}-${shiftType}`;
					const isUserRejected = oslUserRejected?.hasOwnProperty(key);

					let displayText;

					if (params.row.Response === 'S') {
						displayText = 'Message Sent';
					} else if (params.row.Response === 'R') {
						displayText = 'Rejected';
					} else {
						displayText = isUserRejected ? (
							<>
								Time Out
								<br />
								(User Declined)
							</>
						) : (
							'Time Out'
						);
					}

					return (
						<div style={{ whiteSpace: 'normal', lineHeight: 1.4 }}>
							{displayText}
						</div>
					);
				}
			},
			{
				field: 'Shift_Type', headerName: 'List', flex: 1, minWidth: 120,
			},
			{
				field: 'Hours',
				headerName: 'Boxes',
				flex: 1,
				minWidth: 110,
				valueGetter: (params) => {
					if (params.row.Response == "S") {
						return `${params?.row?.list_hours - params?.row?.Hours}.00 ` + `(+ ${params?.row?.Hours})`;
					}
					else {
						return params?.row?.list_hours;
					}
				}
			},
			{
				field: 'OfferedAt',
				headerName: 'Offered',
				flex: 1,
				minWidth: 90,
				valueGetter: (params) => {
					const empCode = params.row.Emp_Code;
					const fromOfferMap = offerTime[empCode];
					let timeString = fromOfferMap || params?.row?.Create_Time;

					if (!timeString) return '';

					// if (/^\d{2}:\d{2}:\d{2}$/.test(timeString)) {
					// 	timeString = `1970-01-01T${timeString}Z`;
					// } else {
					// 	timeString += 'Z';
					// }

					const date = new Date(timeString);
					if (isNaN(date.getTime())) return '';

					// if (!fromOfferMap) {
					// 	date.setTime(date.getTime() + 3600000);
					// }

					return date.toLocaleTimeString('en-US', {
						hour: 'numeric',
						minute: 'numeric',
						second: 'numeric',
						hour12: false,
						// timeZone: 'America/New_York'
					});
				}
			},
		];
		if (!isWatchParty) {
			columns.push(
				{
					field: 'Actions', headerName: 'Actions', flex: 0, minWidth: 450,
					renderCell: (params) => {
						const empCode = params?.row?.Emp_Code;
						const isInOlpShifts = olpShifts?.hasOwnProperty(empCode);
						const shiftDetails = olpShifts?.[empCode];
						const showStatus = shiftDetails?.Status || '';

						return (
							<>
								{(params?.row?.Response === 'R') ? (
									<Button
										variant="contained"
										sx={{
											backgroundColor: 'rgba(230, 39, 25, 0.1)',
											color: 'rgba(230, 39, 25, 1)',
											border: '1px solid rgba(230, 39, 25, 0.4)',
											borderRadius: '30px',
											padding: '4px',
											width: '39%',
											boxShadow: 'none',
											cursor: 'none',
											'&:hover': {
												backgroundColor: 'rgba(230, 39, 25, 0.1)',
												boxShadow: 'none',
											},
										}}
									>
										Rejected
									</Button>
								)
									: (
										<>
											<Button
												variant="contained"
												onClick={() => {
													setShowAccept(true);
													setAcceptData(params.row);
												}}
												sx={{
													backgroundColor: '#01784F',
													color: '#ffffff',
													marginLeft: '10px',
													padding: '8px',
													boxShadow: 'none',
													'&:hover': {
														backgroundColor: '#01784F',
														boxShadow: 'none',
													},
												}}
												disabled={rowSelectionModel.length === 0}
											>
												{acceptText.V3_FILL_SHIFT_ACCEPT_TEXT || 'Accept'}
											</Button>
											<Button
												variant="contained"
												onClick={() => {
													setShowReject(true);
													setRejectapiData(params.row);
												}}
												sx={{
													backgroundColor: '#ff0000',
													color: '#ffffff',
													marginLeft: '10px',
													padding: '8px',
													boxShadow: 'none',
													'&:hover': {
														backgroundColor: '#E62719',
														boxShadow: 'none',
													},
												}}
											>
												Reject
											</Button>
										</>
									)}

								{isInOlpShifts && pages.includes("ACCEPT_SHIFT_PASS") &&
									<>
										{showStatus == 'REQUESTED' &&
											<>
												<Button
													onClick={() => { acceptRejectReq(params?.row, "approve") }}
													style={{
														backgroundColor: 'rgba(1, 120, 79, 0.1)',
														border: '1px solid rgba(1, 120, 79, 0.4)',
														color: 'rgba(1, 120, 79, 1)', margin: '0px 12px'
													}}>
													<img src='/images/right-check.svg' height='16px' width='16px' style={{ marginRight: '6px' }} />
													RFP {"(" + moment(olpShifts?.[params?.row?.Emp_Code]?.Shift_Date).format("M/DD/Y") + ")"}
												</Button>

												<Button
													onClick={() => { acceptRejectReq(params?.row, "deny") }}
													style={{
														backgroundColor: 'rgba(230, 39, 25, 0.1)',
														border: '1px solid rgba(230, 39, 25, 0.4)',
														color: 'rgba(230, 39, 25, 1)'
													}}>
													<img src='/images/cross-check.svg' height='16px' width='16px' style={{ marginRight: '6px' }} />
													RFP
												</Button>
											</>
										}

										{showStatus == 'APPROVED' &&
											<Button
												style={{
													backgroundColor: 'rgba(1, 120, 79, 0.1)',
													border: '1px solid rgba(1, 120, 79, 0.4)',
													fontSize: '12px',
													color: 'rgba(1, 120, 79, 1)', margin: '0px 12px'
												}}>
												{`RFP ${showStatus}`}
											</Button>
										}

										{showStatus == 'DECLINED' &&
											<Button
												style={{
													backgroundColor: 'rgba(230, 39, 25, 0.1)',
													border: '1px solid rgba(230, 39, 25, 0.4)',
													fontSize: '12px',
													color: 'rgba(230, 39, 25, 1)',
													margin: '0px 12px'
												}}>
												{`RFP ${showStatus}`}
											</Button>
										}

										<div style={{ cursor: 'pointer', marginLeft: '16px' }}
											onClick={() => {
												setShow(true)
												requestRFP(params?.row)
											}
											}>
											<img src='/images/comment.svg' height='20px' width='20px' />
										</div>
									</>
								}
							</>
						)
					}
				}
			)
		}
		return columns
	}

  let columnsJobDiscarded = [
    {
      field: 'fullName', headerName: 'Name', flex: 1, minWidth: 200,
      valueGetter: (params) => {
        return `${params?.row?.EA_Rank || ''} ${params?.row?.fullName || ''} ${params?.row?.employee?.employee_assignment?.EA_Rank || ''} ${params?.row?.employee?.fullName || ''}`
      }
    },
    {
      field: 'EMS_Cert', headerName: 'Not Offered', flex: 1, minWidth: 100,
			valueGetter: (params) => {
        return `${params?.row?.employee?.EMS_Cert || ''}`;
      }
    },
    {
      field: 'Reason', headerName: 'Reason', flex: 1, minWidth: 200,
      valueGetter: (params) => {
        return `${params?.row?.discard_reason || ''} ${params?.row?.Reason || ''}`;
      }
    },
  ];

  let columnsJobsTob = [
    {
      field: 'image',
      headerName: '',
      flex: 0,
      maxWidth: 50,
      renderCell: (params) => {
        return (
          params?.row?.progress_details?.pending_jobs === 0 ? (
            <img
              src="/images/timer-unactive.svg"
              style={{ width: '22px', height: '22px' }}
            />
          ) : (
            <img
              src="/images/timer-active.svg"
              style={{ width: '22px', height: '22px' }}
            />
          )
        );
      },
    },
    {
      field: 'Shift_Date',
      headerName: 'Date',
      flex: 1,
      minWidth: 150,
      filterable: false,
      valueGetter: (params) => {
        return moment(params.row.Shift_Date).format('ddd Do, MMMM YYYY');
      }
    },
    {
      field: 'Shift_Number',
      headerName: 'S_No.',
      flex: 1,
      minWidth: 60,
      filterable: false,
      valueGetter: (params) => (params.row.Shift_Number)
    },
    {
      field: 'Orig_Emp_fullName',
      headerName: 'Name',
      flex: 1,
      minWidth: 180,
      valueGetter: (params) => {
        return (params?.row?.orig_emp?.fullName) ? params?.row?.orig_emp?.employee_assignment?.EA_Rank + ' ' +  params?.row?.orig_emp?.fullName : "Detail";
      },
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: 'normal',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '1.5',
              wordBreak: 'break-word'
            }}
          >
            {params.value}
          </div>
        );
      }
    },
    {
      field: 'Overtime_List',
      headerName: 'List',
      flex: 1,
      minWidth: 110,
      renderCell: (params) => {
        return (
          <div
            style={{
              whiteSpace: 'normal',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              lineHeight: '1.5',
              wordBreak: 'break-word'
            }}
          >
            {params.value}
          </div>
        );
      }
    },
    {
      field: 'EMT',
      headerName: 'EMT',
      flex: 1,
      minWidth: 80
    },
		{
      field: 'filled_employee',
      headerName: 'Action',
      flex: 1,
      minWidth: 160,
      renderCell: (params) => {
        return (
					params?.row?.Status == 'F' ?
					(
						<Chip
							sx={{
									height: 'auto',
									'& .MuiChip-label': {
											display: 'block',
											whiteSpace: 'normal',
									},
							}}
							style={{ textAlign: 'center', padding: '6px 0px', width: '100%', backgroundColor: '#079E46' , color:'#ffffff' ,cursor: 'pointer' }}
							label={params?.row?.filled_employee?.employee?.fullName}
						/>
					) : "Not filled"
        );
      }
    },
  ];
	
  const handlePauseConfirm = async () => {
    setSubmitingPause(true);

    try {
      await ApiService.post('/pausePatchJobs', {
        id: job_id,
        action: isPaused ? 'pause' : 'restart',
        Timer: timer,
        batch_number: batch_id,
      });
      navigate("/firehouse/fill-shift");
    } catch (error) {
      setSubmitingPause(false);
      navigate("/firehouse/fill-shift");
    }
  };

	const handleBackClick = () => {
		if (isWatchParty) {
			navigate(-1);
		}
		else {
			if (!isPaused || !patchId) {
				clearInterval(intervalId.current);
				setViewJobs(false);
				setSubmiting(false);
				setBackMode(false);
				setFromPreAccept(false);
				setViewJobsEmp([]);
				setViewJobsEmpDiscard([]);
				navigate("/firehouse/fill-shift");
			} else {
				setShowModal(true);
			}
		}
  };

  const handleBack = () => {
    clearInterval(intervalId.current);
    setViewJobs(false);
    setSubmiting(false);
    setBackMode(false);
    setFromPreAccept(false);
    setViewJobsEmp([]);
    setViewJobsEmpDiscard([]);
    navigate("/firehouse/fill-shift");
  }

  useEffect(() => {
    if (scrollToRef.current) {
      scrollToRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, [empNowSending]);

  let OvertimeData = () => {
    setLoading(true);
    ApiService.post('/getShiftsToFillFromBatch', {
      "batch_number": batch_id,
    }).then((data) => {
      const formattedData = data?.map((row, index) => ({
        ...row,
        id: row.id || index,
				page : 'fillShift'
      }));

			const formattedDataNew = data
				?.filter(row => row.Status === 'O')
				.map((row, index) => ({
					...row,
					id: row.id || index,
			}));

      if (formattedDataNew.length === 0) {
        handleBack();
      }
      setOverTime(formattedData);
      setLoading(false);
    }).catch((e) => {
      setLoading(false);
      toast.error(e?.data?.message)
    });
  };

  let PatchPause = async () => {
    setSubmitingPause(true);
    Checkstatus();
    try {
      await ApiService.post('/pausePatchJobs', {
        id: job_id,
        action: isPaused ? 'pause' : 'restart',
        Timer: timer,
        batch_number: batch_id,
      });
    } catch (error) {
      console.error(error?.response?.data || error);
      Checkstatus();
    } finally {
      setSubmitingPause(false);
      setIsPaused((pre) => !pre);
    }
  };

	const emergencyPause = () => {
		const body = {
        id: job_id,
        action: 'pause',
        Timer: timer,
        batch_number: batch_id,
      }
    ApiService.post('/pausePatchJobs', body)
		.then((data) => {
		})
		.catch((error) => {
    })
  }

	let RestartShift = async () => {
		try {
			const keys = Object.keys(rankChangeData);
			const lastKey = keys[keys.length - 1];      
			const listValue = rankChangeData[lastKey]; 
			const empCode = lastKey;   

			const response = await ApiService.post('/removeRankChangeAndRestart', {
				batch_number: batch_id,
				EmpCode: empCode,
				list: listValue,
			});

			toast.success(response?.message);
		} catch (error) {
			console.error(error?.data || 'error');
			toast.error(error?.data?.message);
		} finally {
			console.error('error');
		}
	}

	let RestartShiftGrenga = async () => {
		try {
			const keys = Object.keys(grengaList);
			const lastKey = keys[keys.length - 1];           
			const empCode = grengaList[lastKey];        
			const listValue = lastKey.split('-')[0]; 

			const response = await ApiService.post('/removeGrengaAndRestart', {
				batch_number: batch_id,
				EmpCode: empCode,
				list: listValue,
			});

			toast.success(response?.message);
		} catch (error) {
			console.error(error?.data || 'error');
			toast.error(error?.data?.message);
		} finally {
			console.error('error');
		}
	}

  let Checkstatus = () => {
    ApiService.post('/checkjobstatus', {
      batch_number: batch_id,
      timer: timerRef.current
    }).then((data) => {
      if (data.data) {
        setPauseGrenga(data.data.status);
        if ((data.data.status !== undefined && data.data.status === "pause") || data.data.status === 'pause_last_rank') {
          setIsPaused(false);
        }else if(data.data.status !== undefined && data.data.status === "restart"){
           setIsPaused(true);
        }
      }
    }).catch((e) => {
      toast.error(e?.data?.message)
    });
  };

  let getJobData = (patchIds) => {
    ApiService.get('/getMybatchs', { patchIds: patchIds }).then(response => {
      setFromPreAccept(false);
      const jobsData = Object.values(response.data);

      if (jobsData.length === 0) {
        clearInterval(intervalId.current);
        setProgressValue(100);
        setSubmiting(false);
        setPatchId('');
      } else {
        const firstJobData = jobsData[0];
        if (firstJobData.total_jobs) {
          if (empNowSending !== (firstJobData.total_jobs - firstJobData.pending_jobs)) {
            setTimerCount(5);
          }

          setProgressValue((firstJobData.total_jobs - firstJobData.pending_jobs) * 100 / firstJobData.total_jobs);
					setCount(`${firstJobData.total_jobs - firstJobData.pending_jobs} / ${firstJobData.total_jobs}`)
          setEmpNowSending(0);

          setPatchId(firstJobData.id);

          // const notOfferedCodes = firstJobData?.options?.emps_not_offered;
          // setViewJobsEmp(firstJobData.options.osl_shifts
          //   .filter(item => !notOfferedCodes.includes(item.Emp_Code))
          //   .map(item => {
          //     return { ...item , id: item.Emp_Code }
          //   })
          // )

					// setViewJobsEmp(firstJobData?.options?.osl_shifts.map(item => {
          //   item.id = item.Emp_Code;
          //   return item;	
          // }));
          setViewJobsEmp([...firstJobData?.options?.osl_shifts]);

          // setViewJobsEmpDiscard([...firstJobData?.options?.not_offered.map(item => {
          //   item.id = item.Emp_Code;
          //   return item;	
          // })]);
          setViewJobsEmpDiscard([...firstJobData?.options?.not_offered]);

          // setNotOfferedEmp(firstJobData.options.not_offered.map(item => {
          //   item.id = item.Emp_Code;
          //   return item;
          // }));

          setNewDataArray(firstJobData?.options?.rfp_requests);
          setShiftDate(firstJobData?.options?.ShiftDate)
          setShiftCode(firstJobData?.options?.Shift_Code)
          setShiftNumber(firstJobData?.options?.ShiftNumber)
          setRejectData(firstJobData?.options?.reject_requests)
          setEmpsNoMarks(firstJobData?.options?.emps_no_marks)
					setOfferTime(firstJobData?.options?.offered_time)
					setGrengaList(firstJobData?.options?.os_grenga_two)
					setOlpShifts(firstJobData?.options?.olp_shifts)
					setOslUserRejected(firstJobData?.options?.osl_shifts_userrejected)
					setRankChangeData(firstJobData?.options?.os_rank_change)
					setGrengaDeactiveList(firstJobData?.options?.os_grenga_deactive)
        }
        else {
          // setViewJobsEmp(jobsData[0]?.options?.osl_shifts?.map(item => {
          //   item.id = item.Emp_Code;
          //   return item;
          // }));
          setViewJobsEmp([...jobsData[0]?.options?.osl_shifts])

          // setViewJobsEmpDiscard(jobsData[0]?.options?.not_offered?.map(item => {
          //   item.id = item.Emp_Code;
          //   return item;
          // }));
           setViewJobsEmpDiscard([...jobsData[0]?.options?.not_offered]);

          // setNotOfferedEmp(jobsData[0].options.not_offered.map(item => {
          //   item.id = item.Emp_Code;
          //   return item;
          // }));

          setNewDataArray(jobsData[0]?.options?.rfp_requests);
          setShiftDate(jobsData[0]?.options?.ShiftDate)
          setShiftCode(jobsData[0]?.options?.Shift_Code)
          setShiftNumber(jobsData[0]?.options?.ShiftNumber)
          setRejectData(jobsData[0]?.options?.reject_requests)
          setEmpsNoMarks(jobsData[0]?.options?.emps_no_marks)
					setOfferTime(jobsData[0]?.options?.offered_time)
					setGrengaList(jobsData[0]?.options?.os_grenga_two)
					setOlpShifts(jobsData[0]?.options?.olp_shifts)
					setOslUserRejected(jobsData[0]?.options?.osl_shifts_userrejected)
					setRankChangeData(jobsData[0]?.options?.os_rank_change)
					setGrengaDeactiveList(jobsData[0]?.options?.os_grenga_deactive)
        }
      }
    }).catch(error => {
      // toast.error("Failed to fetch job data")
    });
  };

  const handleCellClick = (params) => {
		const selectedId = params.id;
		const selectedRow = overTime.find(row => row.id === selectedId);

		if (selectedRow?.Status === 'F') {
			return;
		}

		setRowSelectionModel([selectedId]);
		setSelectedShift(selectedRow);
	};

	const onRowSelectionModelChange = (newSelection) => {
		const selectedId = newSelection[0];
		const selectedRow = overTime.find(row => row.id === selectedId);

		if (selectedRow?.Status === 'F') {
			setRowSelectionModel([]);      
			setSelectedShift(null);
			return;
		}

		setRowSelectionModel([selectedId]);
		setSelectedShift(selectedRow);
	};

  const AcceptEmployeeSelectedShift = (row) => {
		if (rowSelectionModel.length > 0 && selectedShift) {
			setShowAccept(false);
			setLoading(true);

			ApiService.post('/acceptShiftToEmployee', {
				ShiftDate: selectedShift?.Shift_Date,
				ShiftNumber: selectedShift?.Shift_Number,
				batch_number: batch_id,
				EmpCode: row?.Emp_Code,
				Status: "A",
			})
				.then((data) => {
					toast.success(data.message);
					setRowSelectionModel([]);
					setReloadData(true);
					setLoading(false);
				})
				.catch((error) => {
					const message = error?.data?.message || "Unknown error";
					toast.error(message);
					setLoading(false);
				});
		}
	};

  useEffect(() => {
    const patchIds = params.job_id;
    getJobData([patchIds]);
    Checkstatus();
    const timer = setInterval(() => {
      getJobData([patchIds]);
      Checkstatus();
    }, 5000);
    return () => clearInterval(timer);
  }, [params.job_id]);

  useEffect(() => {
    setLoading(false);
    OvertimeData();
    const timer = setInterval(() => {
      OvertimeData();
      setLoading(false);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (reloadData) {
      OvertimeData();
      setReloadData(false);
      setLoading(false);
    }
  }, [reloadData]);

  const acceptRejectReq = (row, decision) => {
		const shiftDetails = olpShifts?.[row?.Emp_Code]; 
		const shiftDate = shiftDetails?.Shift_Date || ''; 
		const shiftCode = shiftDetails?.Overtime_List || '';

    ApiService.post("/request-rfp-admin-decision", {
      "Shift_Date": shiftDate,
      "Shift_Code": shiftCode,
      "Emp_Code": row?.Emp_Code,
      "Status": 'R',
      "batch_number": batch_id,
      "list" : row?.Shift_Type,
			"decision": decision,
    })
      .then((data) => {
        toast.success(data?.message)
        const patchIds = params.job_id;
        getJobData([patchIds]);
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  }

  const requestRFP = (row) => {
		const empCode = row?.Emp_Code;
		const shiftDetails = olpShifts?.[empCode]; 
    ApiService.post("/rfp-request-fetch", {
      "Shift_Date": shiftDetails?.Shift_Date,
      "Shift_Code": shiftDetails?.Overtime_List,
      "Emp_Code": empCode,
    })
      .then((data) => {
        setRequestMessage(data?.data)
      })
      .catch((error) => {
        console.error(error?.data?.message)
      });
  }

  useEffect(() => {
    ApiService.get('/v3Variables')
      .then((res) => {
        setAcceptText(res?.data?.data)
				setAllowedVars(res?.data?.data)
      }).catch(({ error }) => {
        console.log('error', error)
      });
  }, [])

  const rejectEmployee = (row) => {
    ApiService.post("/rejectShiftToEmployee", {
      "EmpCode": row.Emp_Code,
      "Status": 'R',
      "batch_number": batch_id,
      "list" : row.Shift_Type
    })
      .then((data) => {
        setShowReject(false)
        toast.success(data?.message)
        const patchIds = params.job_id;
        getJobData([patchIds]);
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  }
  useEffect(() => {
    ApiService.get('/v3Variables')
      .then((res) => {
        setAcceptText(res?.data?.data)
      }).catch(({ error }) => {
        console.log('error', error)
      });
  }, [])

	const getEmergencyCallEmp = () => {
		setLoading(true)
		ApiService.get(`/getEmergencyCallEmployees/${batch_id}`)
		.then(({data}) => {
			setLoading(false);
			if(data?.data.length > 0){
				setListType(data?.data[0]?.list_name)
				setListArr(data?.data[0]?.employees)
				setEmergencyList(data?.data)
			}
		})

		.catch((e) => {
			setLoading(false);
			console.error(e, 'err')
		})}

	const sendEmergencyCall = () => {
		setEmergencyPauseLoad(true)
		ApiService.get(`/sendEmergencyCallToEmployees/${batch_id}`)
		.then(({data}) => {
			setLoading(false);
			setEmergencyPauseLoad(false)
			toast.success(data?.message)
			setShowModal2(false)
		})

		.catch((error) => {
			setLoading(false);
			toast.error(error?.message)
		})}

  return (
    <>
      <Paper className="p-3" style={{ marginTop: "1rem" }} sx={{ maxWidth: '93vw', overflowX: 'auto', background: '#FFF', position: 'relative' }}>
        <Box className="my-1" sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Typography variant="h6" style={{ marginBottom: "10px" }}>
            Fill Overtime
					</Typography>

				<div>
					{(allowedVars && Object.keys(allowedVars).includes('V3_EMERGENCY_FILLS')) &&
					<ButtonTheme color='primary' className='mx-4'
							onClick={() =>{
								setShowModal2(true)
								getEmergencyCallEmp()
								emergencyPause()
							}}>
							Emergency Fill
					</ButtonTheme>}

          <Button style={{ color: '#555555' }} onClick={handleBackClick}>
            <img src="/images/back-button.svg" alt="icon" width='30px' height='30px' />
          </Button>
				</div>
        </Box>

				<div style={{display:'flex' , justifyContent:'space-between' , alignItems:'center' , marginTop:'10px'}}>
					<Box>
						{Array.isArray(overTime) && overTime.length > 0 && (() => {
							const uniqueLists = Array.from(
								new Set(overTime.map((row) => row?.Overtime_List).filter(Boolean))
							);

							return (
								<Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 1 }}>
									<Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
										List being called:
									</Typography>
									{uniqueLists.map((item, index) => (
										<Chip
											key={index}
											label={item}
											sx={{
												fontSize: '12px',
												backgroundColor: 'rgb(191, 29, 45 , 0.8)',
												color: 'white'
											}}
										/>
									))}
								</Box>
							);
						})()}
					</Box>
					{rankChangeData && Object.keys(rankChangeData).length > 0 && (() => {
						const keys = Object.keys(rankChangeData);
						const lastKey = keys[keys.length - 1];      
						const listValue = rankChangeData[lastKey]; 
						const empCode = lastKey;   

						return (
							<Box>
								<Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 1 }}>
									<Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
										Pause due to Rank Change , List : {listValue} 
									</Typography>
									<ButtonTheme color='primary' onClick={RestartShift} style={{ marginLeft: '5px' }}>
										{'Restart'}
									</ButtonTheme>
								</Box>
							</Box>
						);
					})()}

					{grengaList && Object.keys(grengaList).length > 0 && (() => {
						const keys = Object.keys(grengaList);
						const lastKey = keys[keys.length - 1];          
						const listValue = lastKey.split('-')[0]; 
						const empCode = grengaList[lastKey];

						return (
							<Box>
								<Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 1, mb: 1 }}>
									<Typography sx={{ fontSize: '14px', fontWeight: 500 }}>
										Pause due to Grenga , List : {listValue} 
									</Typography>
									<ButtonTheme color='primary' onClick={RestartShiftGrenga} style={{ marginLeft: '5px' }}>
										{'Restart'}
									</ButtonTheme>
								</Box>
							</Box>
						);
					})()}
				</div>

        {loading ? (
          <Box className="w-100 h-100 d-flex justify-content-center align-items-center">
            <CircularProgress />
          </Box>
        ) : (
          <>
            <div>
              <Grid container spacing={1}>
                <Grid item xs={8.5}>
										<div className="hide-header-checkbox-page">
											<CollapseComponent
												rows={overTime}
												columns={columnsJobsTob}
												name={`Overtime Shift`}
												checkboxSelection={isWatchParty ? false : true}
												isRowSelectable={(params) => params.row.Status !== 'F'}
												onCellClick = {handleCellClick}
												open={true}
												rowSelectionModel={rowSelectionModel}
												onRowSelectionModelChange={onRowSelectionModelChange}
											/>
										</div>
                </Grid>
                <Grid item xs={3.5}>
                  <p
                    className="w-100 text-dark d-flex justify-content-between  p-2 border-0 my-2"
                    style={{ backgroundColor: 'rgb(191, 29, 45)' }}
                  >
                    <span style={{ fontWeight: "400", color: 'white' }}>Offered</span>
										<div style={{
											marginBottom: "0px",
											marginLeft: '60%',
											borderRadius: '12px',
											backgroundColor: '#ffffff',
											minWidth:'68px',
											height:'24px',
											display:'flex',
											alignItems:'center',
											justifyContent:'center'
										}}>
											<p style={{ fontSize: '12px', fontWeight:'550' , margin: 0 , color:'#000000'}}>
												{count}
											</p>
										</div>
                  </p>
                  <div style={{ border: '1px solid #ccc' }}>
                    <TableContainer>
                      <Table sx={{ maxWidth: "90vw", overflow: "scroll" }} aria-label="simple table">
                        <TableHead sx={{ backgroundColor: "#E5E9EB" }} >
                          <TableRow>
														<TableCell width="25%">Jobs</TableCell>
                            <TableCell width="30%">Timer</TableCell>
                            <TableCell width="45%">Action</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                            {/* {isPaused ? (
                              <TableCell width="10%">
                                {viewJobsEmp.length > 0 && viewJobsEmp[0].Create_Time ? (() => {
																	let timeString = viewJobsEmp[0].Create_Time;

																	if (/^\d{2}:\d{2}:\d{2}$/.test(timeString)) {
																		timeString = `1970-01-01T${timeString}Z`;
																	} else {
																		timeString += 'Z';
																	}

																	const date = new Date(timeString);
																	if (isNaN(date.getTime())) return '';

																	date.setTime(date.getTime() + 3600000);

																	return date.toLocaleTimeString('en-US', {
																		hour: 'numeric',
																		minute: 'numeric',
																		second: 'numeric',
																		hour12: false,
																		timeZone: 'America/New_York'
																	});
																})() : ''}
                              </TableCell>
                            ) : (
                              <TableCell width="10%">
                                <input type="text" className="form-control shadow-none"
                                  style={{ maxWidth: '60px', fontSize: '12px' }}
                                  value={timer}
																	onChange={(e) => {
																		const value = e.target.value;
																			if (/^\d*$/.test(value)) {
																				const newTimer = Number(value);
																				setTimer(newTimer);
																				localStorage.setItem('Timer', JSON.stringify([newTimer]));
																			}
																		}}
                                />
                              </TableCell>
                            )} */}

														<TableCell width="25%">
															 {count}
														</TableCell>

														<TableCell width="30%">
															 {isPaused ? 
															    <Timer seconds={timerCount} setSeconds={setTimerCount} /> 
																	: 
																	<div>
																		<input type="text" className="form-control shadow-none"
																			style={{ width : '60px', fontSize: '12px' }}
																			value={timer}
																			onChange={(e) => {
																				const value = e.target.value;
																					if (/^\d*$/.test(value)) {
																						const newTimer = Number(value);
																						setTimer(newTimer);
																						localStorage.setItem('Timer', JSON.stringify([newTimer]));
																					}
																				}}
																		/>
																	</div>
																}
														</TableCell>

                            <TableCell width="45%">
                              {pauseGrenga === 'pause_last_rank' ?
                                <>
                                  <img src="/images/onduty.svg" width='20px' height='20px' style={{ marginRight: '5px' }} />
                                  Rank Pause
                                </>
                                : ''
																}
																{!isWatchParty &&
																	<ButtonTheme disabled={submitingPause} color='primary' onClick={PatchPause} style={{ marginLeft: '5px' }}>
																		{isPaused ? submitingPause ? 'Pausing...' : 'Pause' : submitingPause ? 'Restarting...' : 'Restart'}
																	</ButtonTheme>
																}
                            </TableCell>
                          </TableRow>
                        </TableBody>
                      </Table>
                    </TableContainer>
                    <LinearProgressWithLabel value={ProgressValue} className='mx-2'></LinearProgressWithLabel>
                  </div>
                </Grid>
              </Grid>

              <div>
                {patchId && returnbatches && returnbatches.includes(patchId) && returnbatches?.findIndex((x) => x == patchId) != 0 &&
                  <Alert icon={<CheckIcon fontSize="inherit" />} severity="success">
                    ( {returnbatches?.findIndex((x) => x == patchId)} )  Shift is Done
                  </Alert>
                }

                <div>
                  <ModalBox
                    open={showModal}
                    onClose={handleModalClose}
                    title="Pause Job"
                    body="Do you want to pause the job before leaving?"
                    primaryAction={handlePauseConfirm}
                    primaryActionText="Yes, Pause & Go Back"
                    secondaryActionText="Cancel"
                    isPrimaryDisabled={submitingPause}
                    secondaryAction={handleModalClose}
                    isTertiaryDisabled={submitingPause}
                    tertiaryAction={handleBack}
                    tertiaryActionText="Only Go Back"
                  />
                </div>
              </div>

              <CollapseComponent
                name={"Offered"}
								// isShowMoreData = {true}
                checkboxSelection={false}
                rows={viewJobsEmp}
                columns={columnsJobs()}
                useTopFilter={false}
                rowCount={viewJobsEmp.length}
                open={true}
              />

              <CollapseComponent
                name={"Not offered"}
								// isShowMoreData = {true}
                checkboxSelection={false}
                rows={[...viewJobsEmpDiscard, ...notOfferedEmp]}
                columns={columnsJobDiscarded}
                useTopFilter={false}
                rowCount={viewJobsEmpDiscard.length + notOfferedEmp.length}
              />
            </div>
          </>
        )}
      </Paper>

      <Modal show={show}
        onHide={() => {
          setShow(false);
          setRequestMessage('')
        }}>
        <Modal.Header closeButton>
          <Modal.Title>Request Free Pass</Modal.Title>
        </Modal.Header>
        <Modal.Body className='pb-4'>{requestMessage || ''}</Modal.Body>
      </Modal>

      <Modal show={showAccept} onHide={() => setShowAccept(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Accept</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: '#555555' }}>
            Are you sure to Accept ?
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setShowAccept(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => AcceptEmployeeSelectedShift(acceptData)}>
                Accept
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={showReject} onHide={() => setShowReject(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Reject</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div style={{ color: '#555555' }}>
            Are you sure to Reject ?
          </div>
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => setShowReject(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => rejectEmployee(rejectapiData)}>
                Reject
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

			{/* Emergency Shift Modal */}
			<div className='font-fam'>
							<Modal show={showModal2} size="lg"
								onHide={() => {
									setShowModal2(false)
								}}>
			
								<Modal.Header closeButton>
									<Modal.Title>Emergency Call List</Modal.Title>
								</Modal.Header>
			
								<Modal.Body style={{ padding: 22 }}>
									<Box id="modal-modal-description">

										{/* Chip Button */}
										<div className="row-em">

										<Grid container item md={12} gap={2} className="calllist" style={{scrollbarWidth: 'none'}}>
										{emergencyList?.length > 0 && emergencyList?.map((row) => (
												<Grid item xs={6} sm={6} md={3}>
													<div className={listType == row?.list_name ? 'tab-active' : 'tab-white'}
														onClick={() => {
															setListType(row?.list_name)
															setListArr(row?.employees)
														}}>
														{`${row?.list_name} (${row?.employees?.length})`}
													</div>
												</Grid>))}
									</Grid>
										<Grid item xs={6} sm={6} md={3} style={{width: '165px'}}>
											<ButtonTheme type='submit' variant="filled" color='primary' style={{width: '150px'}} 
												onClick={() => sendEmergencyCall()} disabled={emergencyPauseLoad == true}>
												{emergencyPauseLoad ? 'Sending...' :'Emergency Call'}
											</ButtonTheme>
										</Grid>	
										</div>

								
										<div style={{ maxHeight: '60vh', overflow: 'scroll', scrollbarWidth: 'none' }}>
											<TableContainer component={Paper} sx={{
												boxShadow: 'none !important',
												border: '1px solid #EAECF0',
												mt: 2
											}}>

												<Table aria-label="customized table">
													<TableHead sx={{ backgroundColor: "#E5E9EB" }} >
														<TableRow>
															<TableCell>Name</TableCell>
														</TableRow>
													</TableHead>

													<TableBody>
														{listArr?.length > 0 ? listArr?.map((row) => (
															<TableRow sx={{
																height: '22px',
																'& .MuiTableCell-root': {
																	border: 'none'
																},
																'&:nth-of-type(even)': {
																	backgroundColor: 'rgba(204, 204, 204, 0.2)',
																},
															}}>

																<TableCell component="th" scope="row">
																	{row?.employee_assignment?.EA_Rank + " " + row?.fullName}
																</TableCell>
															</TableRow>
														 ))
															:
															<TableRow>
																<TableCell colSpan={4} style={{ textAlign: 'center' }}>
																	No Results found
																</TableCell>
															</TableRow> }
													</TableBody>
												</Table>
											</TableContainer>
										</div>
									</Box>
								</Modal.Body>
							</Modal>
						</div>
    </>
  )
}

export default ShiftWork
